import React from 'react';
import { pieceImage, hidden } from '../constants/pieces';

export default function Square(props) {
  let classes = "square-normal";

  if (props.isLastMoveTo) {
    classes = "square-last-move-to";
  } else if (props.isLastMoveFrom) {
    classes = "square-last-move-from";
  } else if (props.adjacent) {
    classes = "square-adjacent";
  } else if (props.isSelected) {
    classes = "square-selected";
  } else if (props.isSetupValid) {
    classes = "square-setup-valid";
  }

  let background = pieceImage[props.value];
  let imgClass = "";

  if (props.value) {
    if (props.player === "1") {
      imgClass = "player1-background";
      if (props.currPlayer === "2") {
        background = hidden;
      }
    } else if (props.player === "2") {
      imgClass = "player2-background";
      if (props.currPlayer === "1") {
        background = hidden;
      }
    }

    if (props.currPlayer === "wait1" || props.currPlayer === "wait2") {
      background = hidden;
    }
  }

  return (
    <button className={classes} onClick={props.onClick}>
      <img className={imgClass} src={background} alt="" />
    </button>
  );
}
